export enum AccountTab {
  MY_ACCOUNT = 'My Account',
  BASIC_INFO = 'Basic information',
  SOCIAL = 'Social'
}

export enum AccountSection {
  ACCOUNT = 'Account',
  MY_BONUS = 'Bonus',
  HISTORY = 'History',
  SETTINGS = 'Settings'
}

export type LevelTier = 1 | 2 | 3 | 4 | 5
